import { Navigate } from 'react-router-dom'
import { useAppSelector } from '@/app/hooks'
import {
  selectIsAuthenticated,
  selectToken,
  selectUser,
} from '@/features/auth/authSlice'
import { ROLE_RENTER } from '@/types/auth'
import { ROUTE_PATHS } from '@/config/routes'

/**
 * Angular `LauncherComponent` at `/`:
 * - not logged in → `/auth/login`
 * - logged in → `/dashboard`
 *
 * Renter exception (Angular `reactRedirectList` for ROLE_RENTER on `/` and `/dashboard`):
 * → `/applicant/dashboard`
 */
export function RootLauncherRedirect() {
  const isAuthenticated = useAppSelector(selectIsAuthenticated)
  const token = useAppSelector(selectToken)
  const user = useAppSelector(selectUser)

  if (!isAuthenticated) {
    return <Navigate to={ROUTE_PATHS.LOGIN} replace />
  }

  if (token && !user) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white">
        <div className="text-center">
          <svg
            className="mx-auto h-10 w-10 animate-spin text-teal-600"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            aria-hidden
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            />
          </svg>
          <p className="mt-4 text-sm text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  if (user?.current_role?.role_name === ROLE_RENTER) {
    return <Navigate to={ROUTE_PATHS.APPLICANT_DASHBOARD} replace />
  }

  return <Navigate to={ROUTE_PATHS.DASHBOARD} replace />
}
